const STORAGE_KEY = "beyundai_research_chat_sessions_v2";

function safeParse(raw) {
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function loadResearchSessions() {
  const parsed = safeParse(localStorage.getItem(STORAGE_KEY));
  if (!Array.isArray(parsed)) return [];
  return parsed
    .filter((s) => s && typeof s.id === "string")
    .map((s) => ({ ...s, documents: s.documents || [] }))
    .sort((a, b) => (b.updatedAt || 0) - (a.updatedAt || 0));
}

export function saveResearchSessions(sessions) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(sessions || []));
}

export function createResearchSession({ systemPrompt = "" } = {}) {
  const now = Date.now();
  return {
    id: `rs_${now}_${Math.random().toString(36).slice(2, 8)}`,
    title: "New research",
    systemPrompt: String(systemPrompt || "").trim(),
    messages: [],
    documents: [],
    createdAt: now,
    updatedAt: now,
  };
}

export function deriveSessionTitle(messages) {
  const firstUser = (messages || []).find((m) => m.role === "user" && String(m.content || "").trim());
  if (!firstUser) return "New research";
  const text = String(firstUser.content).trim().replace(/\s+/g, " ");
  return text.length > 48 ? `${text.slice(0, 48)}…` : text;
}
